import {
  As,
  Box,
  BoxProps,
  Heading,
  HStack,
  Tag,
  TagProps,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import {FaInfo} from 'react-icons/fa';
import {SimpleStatWrapper} from "./simple-stat-wrapper";

export interface SimpleStatProps extends BoxProps {
  icon?: As;
  iconColor?: string;
  label: string;
  value: string;
  unit?: string;
  caption?: string;
  tag?: TagProps;
}
export const SimpleStat = (props: SimpleStatProps) => {
  const { label, value, icon, iconColor, caption, tag, unit, ...boxProps } =
    props;
  return (
    <SimpleStatWrapper {...boxProps}>
      <Text fontWeight="medium" lineHeight="short">
        {label}
      </Text>
      <HStack spacing="4">
        <Box as={icon || FaInfo} h="6" w="6" fill={"white" || iconColor} />
        <Heading size={useBreakpointValue({ base: "sm", md: "md" })}>
          {value}
          {unit && <Text as="small"> {unit}</Text>}
        </Heading>
      </HStack>
      <HStack spacing="1" fontWeight="medium">
        <Text>{caption}</Text>
        {tag && <Tag {...tag} />}
      </HStack>
    </SimpleStatWrapper>
  );
};
